import { useState, useEffect } from 'react';
import { BpmService } from '../../../../core/services/BpmService';



interface Props {
    idSelector: number;
    onChange: any;
    titulo: string;
}

export const SelectorTramites = ({ titulo, idSelector, onChange }: Props) => {

    const service = new BpmService();
    const [lista, setLista] = useState([]);

    const [id, setID] = useState(idSelector ?? 0);

    useEffect(() => {
        getLista();
    }, [idSelector])

    useEffect(() => {
        onChange(id);
    }, [id])

    const setValue = (e: any) => {
        setID(parseInt(e));
        onChange(id);
    }

    const getLista = () => {
        service.getBusinessClassCatalog(null).subscribe(
            (resp: any) => {
                setLista([]);
                if (resp.DataBeanProperties.ObjectValue) {
                    setLista(resp.DataBeanProperties.ObjectValue);
                }
            }
        );
    }

    return (
        <>
            <label>{titulo}</label>
            <select className="form-select" value={id} onChange={(e) => { setValue(e.target.value) }}>
                <option value={null}>...</option>
                {lista &&
                    lista.map((item: any, _i) => {
                        return (
                            <option key={_i} value={item.DataBeanProperties.IDBusinessClass} >{item.DataBeanProperties.Name}</option>
                        )
                    })
                }
            </select>
        </>
    )
}